var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVrCardboard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M576 64H64C28.801 64 0 92.797 0 128V384C0 419.199 28.801 448 64 448H192.25C217.432 448 240.275 433.234 250.615 410.273L278.375 348.625C286.25 331.125 302.375 320 320 320S353.75 331.125 361.625 348.625L389.375 410.25C399.721 433.227 422.578 448 447.775 448H576C611.199 448 640 419.199 640 384V128C640 92.797 611.199 64 576 64ZM160 304C124.625 304 96 275.375 96 240S124.625 176 160 176S224 204.625 224 240S195.375 304 160 304ZM480 304C444.625 304 416 275.375 416 240S444.625 176 480 176S544 204.625 544 240S515.375 304 480 304Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVrCardboard);
export default __webpack_public_path__ + "static/media/vr-cardboard.76441e275c531ff5d5e0bc1c29635674.svg";
export { ForwardRef as ReactComponent };